import { createRoot } from "react-dom/client";
import LogRocket from "logrocket";

import App from "./App";
import "./index.css";

const logRocketAppIds: Record<string, string> = {
    production: "ottocn/insights-prod-4ete4",
};
const logRocketAppId = logRocketAppIds[process.env.REACT_APP_ENV ?? ""];

if (logRocketAppId) {
    LogRocket.init(logRocketAppId, {
        console: { isEnabled: false },
        dom: { inputSanitizer: true },
        network: {
            requestSanitizer: (request) => { request.body = undefined; return request; },
            responseSanitizer: (response) => { response.body = undefined; return response; },
        },
    });
}

const rootElement = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(rootElement!);

root.render(
    <App />
);